import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import { HpRespPromoModulePromoItem } from './HpRespPromoModulePromoItem';
import { HpSharedModuleContainer } from '../HpSharedModuleContainer/HpSharedModuleContainer';
import { trackPromoImpressions, trackPromoClick } from './helpers/PromoTracking';
import { HpSharedInViewport } from '../HpSharedInViewport/HpSharedInViewport';

class HpRespPromoModuleSecondaryComponent extends Component {
    promoSecondaryModule = get(this.props, 'homepage.promoSecondaryModule');

    handleInitialDisplay = ({ inViewport }) => {
        if (this.promoSecondaryModule && inViewport) {
            const { items } = this.promoSecondaryModule;

            trackPromoImpressions({
                items,
                startingIndex: this.getPromoPrimaryItemsCount(),
            });
        }
    };

    getPromoPrimaryItemsCount() {
        const promoPrimaryItemsCount =
            get(this.props, 'homepage.promoPrimaryModule.totalItemsCount') || 0;

        return promoPrimaryItemsCount;
    }

    render() {
        if (!this.promoSecondaryModule) {
            return null;
        }

        const { items } = this.promoSecondaryModule;

        return (
            <HpSharedModuleContainer addTopGap>
                <HpSharedInViewport
                    stopWhenInViewport
                    onInViewportChange={this.handleInitialDisplay}
                >
                    <div className="rowFlex">
                        {items.map((promotion, index) => (
                            <HpRespPromoModulePromoItem
                                key={promotion.cmsId}
                                promotion={promotion}
                                className={items.length === 1 ? 'colXs12' : 'colLg6 colXs12'}
                                onClick={() =>
                                    trackPromoClick({
                                        item: promotion,
                                        index: index + this.getPromoPrimaryItemsCount(),
                                    })
                                }
                            />
                        ))}
                    </div>
                </HpSharedInViewport>
            </HpSharedModuleContainer>
        );
    }
}

HpRespPromoModuleSecondaryComponent.propTypes = {
    homepage: PropTypes.object.isRequired,
};

export const HpRespPromoModuleSecondary = createFragmentContainer(
    HpRespPromoModuleSecondaryComponent,
    {
        homepage: graphql`
            fragment HpRespPromoModuleSecondary_homepage on Homepage {
                promoSecondaryModule: module(type: "promoSecondary") {
                    ... on PromoModule {
                        items {
                            cmsId
                            link
                            imageUrl @skip(if: $isMobile)
                            mobileImageUrl @include(if: $isMobile)
                        }
                    }
                }
                promoPrimaryModule: module(type: "promoPrimary") {
                    ... on PromoModule {
                        totalItemsCount
                    }
                }
            }
        `,
    }
);
